module.exports = __webpack_public_path__ + "img/Icon-Company.b6787ec4.svg";